import { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom"
import { History } from 'history';
import { delay } from "../../framework/utils";
import { AppRoutes, getAppRouteByPathname } from "../app-routes";
import { CurrentUserService } from "../../app/current-user";
import { none } from "../../framework/utils/collection";
import { AppMenuEvents } from "../../events/app-menu";
import { EventNotificationService } from "../../framework/services/event-notification";

const detourUnauthorizedRoute = (goTo: string, history: History<unknown>) => {
    delay(10)
    .then(() => {
        history.push(goTo);
    });
}

export const usePageManager = () => {
    const location = useLocation();
    const history = useHistory();

    useEffect(() => {
        const currentRoute = getAppRouteByPathname(location.pathname);
        if(!currentRoute) {  return; } // the 404 page will be shown

        // we only need to screen secured routes
        if(currentRoute.allowAnonymous === false) {
            CurrentUserService.getBearerToken()
            .then(token => {
                if(!!token) {
                    // empty required roles means any role is authorized
                    if(currentRoute.requiredRoles.length > 0) {
                        if(none(currentRoute.requiredRoles, r => r === token.claims.role)) {
                            detourUnauthorizedRoute(AppRoutes.home.url(), history);
                        }
                    }
                } else {
                    detourUnauthorizedRoute(AppRoutes.signedOut.url(), history);
                }
            })
        }

        if(currentRoute.sideMenuSupported) {
            EventNotificationService.dispatch(AppMenuEvents.MenuAvailable);
        } else {
            EventNotificationService.dispatch(AppMenuEvents.MenuUnavailable);
        }
    }, [location, history]);
}